<template>
  <v-app-bar class="app-bar" dense height="70">
    <create-lead-dialog
      :is-dialog-open="isLeadDialogOpen"
      :initial-phone-number="phoneNumber"
      :is-initially-contact-search-bar-disabled="true"
      :initial-phone-is-searched="true"
      :initial-is-creating="true"
      @onClose="closeLeadDialog"
      @onCreated="handleCreatedLead" />
    <v-btn
      icon
      :class="`btn-appbar ${hideNavMenu ? 'hidden' : ''}`"
      @click="openCloseDrawerMenu"
      v-if="!isAuthRoute && user && !userHasNoDealer"
      data-cy="btn-navigation-menu">
      <v-icon dense color="white">fa-light fa-bars</v-icon>
    </v-btn>

    <v-toolbar-title :class="{'app-logo-unauthorized': !user && !isAuthRoute}">
      <img class="toolbar-logo click" src="/images/new-logo.svg" @click.prevent="goDashboard" />
    </v-toolbar-title>

    <template v-if="user">
      <div class="my-spacer" />
      <div class="app-bar__search-bar-container">
        <contact-search-bar
          v-if="permissions && permissions.clientHistory.canSee && !userHasNoDealer"
          :no-client-subtitle="$t('contact.search-bar.no-client-subtitle')"
          :client-history-text-button="$t('buttons.view-history')"
          origin="header"
          :initial-phone-number="phoneNumber"
          :is-top-bar="true"
          ref="contactSearchBar"
          @open-lead-dialog="openLeadDialog" />
      </div>
      <div class="my-spacer" />

      <v-btn
        v-if="!isAuthRoute && permissions && permissions.requests.canSee"
        icon
        class="btn-appbar btn-appbar-right"
        to="/requests">
        <v-tooltip bottom>
          <template v-slot:activator="{on, attrs}">
            <v-icon dense color="white" v-bind="attrs" v-on="on"> fa-light fa-message-lines </v-icon>
          </template>
          <span>{{ $t('menu.create-incidence') }}</span>
        </v-tooltip>
      </v-btn>

      <v-btn v-if="!isAuthRoute && !userHasNoDealer" icon class="btn-appbar btn-appbar-right" to="/help">
        <v-tooltip bottom>
          <template v-slot:activator="{on, attrs}">
            <v-icon dense color="white" v-bind="attrs" v-on="on">fa-light fa-circle-question </v-icon>
          </template>
          <span>{{ $t('menu.help') }}</span>
        </v-tooltip>
      </v-btn>

      <v-btn
        v-if="!isAuthRoute && !userHasNoDealer"
        @click="showNewsSection"
        class="btn-appbar btn-appbar-right mr-2"
        icon>
        <v-badge color="yellow" dot :value="newNotifyLength > 0">
          <v-tooltip bottom>
            <template v-slot:activator="{on, attrs}">
              <v-icon dense color="white" v-bind="attrs" v-on="on">fa-light fa-bell</v-icon>
            </template>
            <span>{{ $t('menu.news') }}</span>
          </v-tooltip>
        </v-badge>
      </v-btn>

      <last-news
        v-if="!isAuthRoute && !userHasNoDealer"
        :branch="branchLowerCase"
        :display="newsSection"
        @showNews="showNewsSection"
        @hideNews="hideNewsSection" />

      <!-- Development feature flag -->
      <!-- Webpack will remove this entire element in production builds -->
      <debug-menu v-if="isDevelopment()" />

      <v-divider v-if="!isAuthRoute" vertical class="app-bar-divider user-divider mx-2" />

      <user-info-button
        v-if="!isAuthRoute"
        :user-name="cognitoUserName"
        :user-email="user.login"
        @click="openUserDrawer" />
    </template>
  </v-app-bar>
</template>

<script>
//@ts-ignore
import {mapGetters, mapState} from 'vuex'

import router from '@/router'
import {isDevelopment} from '@/utils/env'

import ContactSearchBar from './contact/ContactSearchBar.vue'
import LastNews from './LastNews.vue'
import CreateLeadDialog from './offer-manager/CreateLeadDialog.vue'
import UserInfoButton from './UserInfoButton.vue'

// Development feature flag
// Webpack will completely remove this import and component in production builds
const components = {LastNews, ContactSearchBar, CreateLeadDialog, UserInfoButton}
if (isDevelopment()) {
  components.DebugMenu = () => import('./DebugMenu.vue')
}

export default {
  name: 'AppHeader',
  components,
  props: ['hideUserMenu', 'hideNavMenu'],
  data() {
    return {
      isLeadDialogOpen: false,
      newsSection: false,
      newNotifyLength: 0,
      phoneNumber: '',
    }
  },
  computed: {
    ...mapState(['permissions']),
    ...mapGetters({
      branch: 'getBranch',
      capabilities: 'getCapabilities',
    }),
    userHasNoDealer() {
      return this.$store.getters.userHasNoDealer
    },
    branchLowerCase() {
      return this.branch?.toLowerCase()
    },
    user() {
      return this.$store.getters.getUser
    },
    cognitoUserName() {
      return this.$store.getters.getCognitoUserName
    },
    group() {
      return this.$store.getters.getGroup
    },
    getDrawerState() {
      return this.$store.getters.getDrawerState
    },
    getUserDrawerState() {
      return this.$store.getters.getUserDrawerState
    },
    branchPreferences() {
      return this.capabilities ?? this.$preferences(this.branch)
    },
    isAuthRoute() {
      const routeName = this.$route.name
      return routeName === 'Login' || routeName === 'AuthCallback'
    },
  },
  methods: {
    isDevelopment() {
      return isDevelopment()
    },
    openUserDrawer() {
      this.$store.dispatch('setUserDrawerState', !this.getUserDrawerState)
    },
    openCloseDrawerMenu() {
      this.$store.dispatch('setDrawerState', !this.getDrawerState)
    },
    goDashboard() {
      // router.go(-1);
      if (this.user) {
        if (this.user.role !== 99) router.push({name: 'Dashboard'})
      } else {
        router.push({name: 'Login'})
      }
    },
    showNewsSection() {
      this.newsSection = true
    },
    hideNewsSection() {
      this.newsSection = false
    },
    openLeadDialog(phoneNumber) {
      this.phoneNumber = phoneNumber
      this.isLeadDialogOpen = true
    },
    closeLeadDialog() {
      this.phoneNumber = ''
      this.isLeadDialogOpen = false
      this.$refs.contactSearchBar.resetSearchBar()
    },
    handleCreatedLead() {
      if (this.$route.name !== 'Leads') {
        this.$router.push({name: 'Leads'})
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.v-menu__content:has(.notifications-popup) {
  top: 60px !important;
  left: unset !important;
  right: 100px !important;
  transform-origin: right top !important;
}
.app-bar {
  z-index: 3 !important;
  background-color: var(--v-primary-base) !important;

  .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: transparent !important;
  }

  &__search-bar-container {
    width: 440px;
  }

  .app-logo-unauthorized {
    margin: 0 20px;
  }

  &-divider {
    align-self: center;
    border-color: rgba(255, 255, 255, 0.3) !important;
  }
  .btn-appbar {
    text-decoration: none !important;
    color: white !important;
    padding: 0 !important;
    border-radius: 100px !important;
    height: 48px !important;
    width: 48px;

    .v-badge__badge {
      color: black !important;
    }
  }

  .user {
    &-divider {
      max-height: 45%;
      min-height: 45%;
      align-self: center;
    }
  }

  .btn-appbar-right {
    & i.v-icon {
      font-size: 20px;
      width: 20px;
      height: 20px;
    }
  }

  .appbar-item {
    font-family: 'ProximaNovaExCnSReg', sans-serif;
    font-size: 22px;
    color: white;
    margin: 0 20px;
    &.appbar-link a {
      color: white !important;
      text-decoration: none !important;
      text-transform: uppercase;
    }
  }
  .toolbar-logo {
    display: block;
    height: 41px;
  }
  .my-spacer {
    -webkit-box-flex: 1 !important;
    -ms-flex-positive: 1 !important;
    flex-grow: 1 !important;
  }
  .appbar-menu-link {
    * {
      text-decoration: none !important;
    }
  }
}

.content-notify-body {
  width: 300px !important;
  height: 400px !important;
  overflow-y: auto;
  background-color: white !important;
}
</style>
